import newsImg from '../Assets/CategoryImage/News-min.png'
import districtImg from '../Assets/CategoryImage/district-min.png'
import educationImg from '../Assets/CategoryImage/education-min.png'
import internationalImg from '../Assets/CategoryImage/international-min.png'
import industrybusinessImg from '../Assets/CategoryImage/Industrybusiness-min.png'
import financeImg from '../Assets/CategoryImage/Finance-min.png'
import workImg from '../Assets/CategoryImage/work-min.png'
import hobbyImg from '../Assets/CategoryImage/hobby-min.png'
import foodImg from '../Assets/CategoryImage/Food-min.png'
import fashionImg from '../Assets/CategoryImage/Fashion-min.png'
import travelImg from '../Assets/CategoryImage/travel.png'
import sportImg from '../Assets/CategoryImage/Sport-min.png'
import paternityImg from '../Assets/CategoryImage/paternity-min.png'
import cultureImg from '../Assets/CategoryImage/Culture-min.png'
import designandartImg from '../Assets/CategoryImage/designandart-min.png'
import technologyImg from '../Assets/CategoryImage/technology-min.png'
import healthImg from '../Assets/CategoryImage/health-min.png'
import theologyImg from '../Assets/CategoryImage/theology-min.png'
import relationshipImg from '../Assets/CategoryImage/relationship-min.png'
import environmentImg from '../Assets/CategoryImage/environment-min.png'

const categories = [
    {label: "News📰", labelCHI: "時事📰", value: "news"},
    {label: "district🏘️", labelCHI: "地區🏘️", value: "district"},
    {label: "education🎓", labelCHI: "教育🎓", value: "education"},
    {label: "international🌍", labelCHI: "國際🌍", value: "international"},
    {label: "industrybusiness🏦", labelCHI: "工商🏦", value: "industrybusiness"},
    {label: "finance📊", labelCHI: "財經📊", value: "finance"},
    {label: "work👔", labelCHI: "上班👔", value: "work"},
    {label: "hobby🎮", labelCHI: "興趣🎮", value: "hobby"},
    {label: "food🍖", labelCHI: "飲食🍖", value: "food"},
    {label: "fashion👗", labelCHI: "潮流👗", value: "fashion"},
    {label: "travel🛫", labelCHI: "旅遊🛫", value: "travel"},
    {label: "sport🏀", labelCHI: "運動🏀", value: "sport"},
    {label: "paternity👪", labelCHI: "親子👪", value: "paternity"},
    {label: "relationship❤️", labelCHI: "感情❤️", value: "relationship"},
    {label: "environmental🌲", labelCHI: "環境🌲", value: "environmental"},
    {label: "culture🥋", labelCHI: "文化🥋", value: "culture"},
    {label: "designandart🎨", labelCHI: "設計藝術🎨", value: "designandart"},
    {label: "technology🤖", labelCHI: "科技🤖", value: "technology"},
    {label: "health🏥", labelCHI: "健康🏥", value: "health"},
    {label: "theology🙏", labelCHI: "神學🙏", value: "theology"},
]

export function getCategoryDisplayName(cateID) {
    return localStorage.getItem("i18n-lang") === 'en' ? categories.find(e => e.value === cateID).label : categories.find(e => e.value === cateID).labelCHI
}

export function getSubCategoryDisplayName(cateID, subCateID) {
    let subCate = getSubCategories(cateID)
    return localStorage.getItem("i18n-lang") === 'en' ? subCate.find(e => e.value === subCateID).label : subCate.find(e => e.value === subCateID).labelCHI
}

export function returnCategoryImage(cateName) {
    if (cateName === "news") {
        return newsImg
    } else if (cateName === "district") {
        return districtImg
    } else if (cateName === "international") {
        return internationalImg
    } else if (cateName === "industrybusiness") {
        return industrybusinessImg
    } else if (cateName === "finance") {
        return financeImg
    } else if (cateName === "work") {
        return workImg
    } else if (cateName === "hobby") {
        return hobbyImg
    } else if (cateName === "food") {
        return foodImg
    } else if (cateName === "fashion") {
        return fashionImg
    } else if (cateName === "travel") {
        return travelImg
    } else if (cateName === "sport") {
        return sportImg
    } else if (cateName === "paternity") {
        return paternityImg
    } else if (cateName === "education") {
        return educationImg
    } else if (cateName === "culture") {
        return cultureImg
    } else if (cateName === "designandart") {
        return designandartImg
    } else if (cateName === "technology") {
        return technologyImg
    } else if (cateName === "health") {
        return healthImg
    } else if (cateName === "theology") {
        return theologyImg
    } else if (cateName === "relationship") {
        return relationshipImg
    } else if (cateName === "environmental") {
        return environmentImg
    }
}

export function getAllCategories() {
    let arr = []
    if (localStorage.getItem("i18n-lang") === 'en') {
        categories.map(e => {
            arr.push({label: e.label, value: e.value})
        })
    } else {
        categories.map(e => {
            arr.push({label: e.labelCHI, value: e.value})
        })
    }

    return arr
}

const newsSub = [
    {label: "媒體界📢", labelCHI: "媒體界📢", value: "1"},
    {label: "政治界", labelCHI: "政治界🏛️", value: "2"},
    {label: "本土🇭🇰", labelCHI: "本土🇭🇰", value: "105"},
]

const districtSub = [
    {label: "香港港島區🏙", labelCHI: "香港港島區🏙️", value: "3"},
    {label: "香港九龍區🌆", labelCHI: "香港九龍區🌆", value: "4"},
    {label: "香港新界區🌃", labelCHI: "香港新界區🌃", value: "5"},
    {label: "地區資訊🚋", labelCHI: "地區資訊🚋", value: "115"},
]

const internationalSub = [
    {label: "國際區🌍", labelCHI: "國際區🌍", value: "6"},
]

const industrybusinessSub = [
    {label: "工程界", labelCHI: "工程界", value: "7"},
    {label: "貿易界", labelCHI: "貿易界", value: "8"},
    {label: "採購界", labelCHI: "採購界", value: "9"},
    {label: "批發界", labelCHI: "批發界", value: "10"},
    {label: "電商界", labelCHI: "電商界", value: "11"},
    {label: "運輸界", labelCHI: "運輸界", value: "12"},
    {label: "工商界", labelCHI: "工商界", value: "13"},

]

const financeSub = [
    {label: "金融界", labelCHI: "金融界", value: "14"},
    {label: "理財師", labelCHI: "理財師", value: "15"},
    {label: "會計師", labelCHI: "會計師", value: "16"},
    {label: "地產界", labelCHI: "地產界", value: "17"},
    {label: "牛熊界", labelCHI: "牛熊界", value: "18"},
    {label: "期權界", labelCHI: "期權界", value: "19"},
    {label: "期指界", labelCHI: "期指界", value: "20"},
    {label: "金滙界", labelCHI: "金滙界", value: "21"},
    {label: "股票界", labelCHI: "股票界", value: "22"},
    {label: "博彩界", labelCHI: "博彩界", value: "23"},
    {label: "保險界", labelCHI: "保險界", value: "24"},
]

const workSub = [
    {label: "印刷界", labelCHI: "印刷界", value: "25"},
    {label: "市場界", labelCHI: "市場界", value: "26"},
    {label: "公關界", labelCHI: "公關界", value: "27"},
    {label: "漁農界", labelCHI: "漁農界", value: "28"},
    {label: "社福界", labelCHI: "社福界", value: "29"},
    {label: "環保界", labelCHI: "環保界", value: "30"},
    {label: "勞工界", labelCHI: "勞工界", value: "31"},
    {label: "裝修界", labelCHI: "裝修界", value: "32"},
    {label: "保安界", labelCHI: "保安界", value: "33"},
    {label: "建築界", labelCHI: "建築界", value: "34"},
    {label: "航空界", labelCHI: "航空界", value: "35"},
    {label: "公務界", labelCHI: "公務界", value: "36"},
    {label: "傳銷界", labelCHI: "傳銷界", value: "37"},
    {label: "美容界", labelCHI: "美容界", value: "38"},
    {label: "婚慶界", labelCHI: "婚慶界", value: "39"},
    {label: "漁農界", labelCHI: "漁農界", value: "40"},
    {label: "護老界", labelCHI: "護老界", value: "41"},
    {label: "殯葬界", labelCHI: "殯葬界", value: "42"},
    {label: "顧問界", labelCHI: "顧問界", value: "43"},
    {label: "風水師", labelCHI: "風水師", value: "44"},
    {label: "化驗師", labelCHI: "化驗師", value: "45"},
    {label: "測量師", labelCHI: "測量師", value: "46"},
    {label: "法律界", labelCHI: "法律界", value: "47"},
    {label: "舞蹈界", labelCHI: "舞蹈界", value: "48"},
    {label: "編劇界", labelCHI: "編劇界", value: "49"},
    {label: "歌唱界", labelCHI: "歌唱界", value: "50"},
    {label: "司儀界", labelCHI: "司儀界", value: "51"},
    {label: "魔術師", labelCHI: "魔術師", value: "52"},
    {label: "演藝界", labelCHI: "演藝界", value: "53"},
    {label: "銷售界", labelCHI: "銷售界", value: "54"},
    {label: "零售界", labelCHI: "零售界", value: "55"},
]

const hobbySub = [
    {label: "車友界🚘", labelCHI: "車友界🚘", value: "56"},
    {label: "寵物界🐈", labelCHI: "寵物界🐈", value: "57"},
    {label: "釣魚界🎣", labelCHI: "釣魚界🎣", value: "58"},
    {label: "二手界✋", labelCHI: "二手界✋", value: "59"},
    {label: "懷舊界🚂", labelCHI: "懷舊界🚂", value: "60"},
    {label: "玩具界🧸", labelCHI: "玩具界🧸", value: "61"},
    {label: "模型界🎎", labelCHI: "模型界🎎", value: "62"},
    {label: "古玩界👑", labelCHI: "古玩界👑", value: "63"},
    {label: "影視界📽️", labelCHI: "影視界📽️", value: "64"},
    {label: "動漫界🍥", labelCHI: "動漫界🍥", value: "65"},
    {label: "電競界🎮", labelCHI: "電競界🎮", value: "66"},
    {label: "攝影界📷", labelCHI: "攝影界📷", value: "67"},
    {label: "閱讀界📒", labelCHI: "閱讀界📒", value: "104"},
    {label: "電玩界🕹️", labelCHI: "電玩界🕹️", value: "106"},
    {label: "軍事界🔫", labelCHI: "軍事界🔫", value: "107"},
    {label: "音樂界🎵", labelCHI: "音樂界🎵", value: "113"},
    {label: "歌曲界🎤", labelCHI: "歌曲界🎤", value: "114"},
    {label: "寫作界🖊️", labelCHI: "寫作界🖊️", value: "115"},
    {label: "種植界🌷", labelCHI: "種植界🌷", value: "120"},
    {label: "文具界🖋️", labelCHI: "文具界🖋️", value: "121"},

]

const foodSub = [
    {label: "飲食界🍝", labelCHI: "飲食界🍝", value: "68"},
    {label: "烹調師🍳", labelCHI: "烹調師🍳", value: "69"},
    {label: "焙烘師🍩", labelCHI: "焙烘師🍩", value: "70"},
    {label: "品酒師🍷", labelCHI: "品酒師🍷", value: "71"},
    {label: "茶藝界🍵", labelCHI: "茶藝界🍵", value: "72"},
]

const fashionSub = [
    {label: "服飾界👰", labelCHI: "服飾界👰", value: "73"},
    {label: "珠寶界💍", labelCHI: "珠寶界💍", value: "74"},
    {label: "鐘錶界⌚", labelCHI: "鐘錶界⌚", value: "75"},
    {label: "髮型師💇", labelCHI: "髮型師💇", value: "76"},
    {label: "化妝師💄", labelCHI: "化妝師💄", value: "77"},
    {label: "造型師🎩", labelCHI: "造型師🎩", value: "78"},
    {label: "網紅界🧒", labelCHI: "網紅界🧒", value: "79"},
    {label: "模特界🚶", labelCHI: "模特界🚶", value: "80"},
]

const travelSub = [
    {label: "旅遊界✈️", labelCHI: "旅遊界✈️", value: "81"},
]

const sportSub = [
    {label: "武術界🥋", labelCHI: "武術界🥋", value: "82"},
    {label: "體育界🏀", labelCHI: "體育界🏀", value: "83"},
    {label: "泳術界🏊", labelCHI: "泳術界🏊", value: "84"},
    {label: "搏擊界🤼", labelCHI: "搏擊界🤼", value: "85"},
    {label: "潛水界🤿", labelCHI: "潛水界🤿", value: "86"},
]

const paternitySub = [
    {label: "育兒界🤱", labelCHI: "育兒界🤱", value: "87"},
]

const educationSub = [
    {label: "教育界🎓", labelCHI: "教育界🎓", value: "88"},
    {label: "補習師👨‍🏫️", labelCHI: "補習師👨‍🏫️", value: "89"},
]

const cultureSub = [
    {label: "文化界🥋", labelCHI: "文化界🥋", value: "90"},
    // {label: "音樂界", labelCHI: "音樂界", value: "91"},
]

const designandartSub = [
    {label: "廣告界📰", labelCHI: "廣告界📰", value: "92"},
    {label: "手工界🔨", labelCHI: "手工界🔨", value: "93"},
    {label: "設計師✏️", labelCHI: "設計師✏️", value: "94"},
    {label: "繪畫師🖼️", labelCHI: "繪畫師🖼️", value: "95"},
    {label: "藝術家👨‍🎨️", labelCHI: "藝術家👨‍🎨️", value: "122"},
]

const technologySub = [
    {label: "科技界🤖", labelCHI: "科技界🤖", value: "96"},
    {label: "電腦界🖥️", labelCHI: "電腦界🖥️", value: "97"},
    {label: "資訊界👨‍💻️", labelCHI: "資訊界👨‍💻️", value: "98"},
    {label: "電子界🎚", labelCHI: "電子界🎚", value: "99"},
]

const healthSub = [
    {label: "醫學界👨‍⚕️", labelCHI: "醫學界👨‍⚕️", value: "100"},
    {label: "心理界💗", labelCHI: "心理界💗", value: "116"},
    {label: "營養界🌮", labelCHI: "營養界🌮", value: "117"},
    {label: "健身界🏋", labelCHI: "健身界🏋", value: "118"},
]

const theologySub = [
    {label: "玄學界🔯", labelCHI: "玄學界🔯", value: "101"},
    {label: "宗教界🙏", labelCHI: "宗教界🙏", value: "102"},
    {label: "星座🔭", labelCHI: "星座🔭", value: "103"},
]

const relationshipSub = [
    {label: "兩性關係👫", labelCHI: "兩性關係👫", value: "108"},
    {label: "同性關係👬", labelCHI: "同性關係👬", value: "109"},
    {label: "家人朋友關係👪", labelCHI: "家人朋友關係👪", value: "110"},
]

const environmentSub = [
    {label: "回收♻️", labelCHI: "回收♻️", value: "111"},
    {label: "環保🗑️", labelCHI: "環保🗑️", value: "112"},
    {label: "自然生態🏞️", labelCHI: "自然生態🏞️", value: "119"},
]

export function getSubCategories(cateName) {
    if (cateName === "news") {
        return newsSub
    } else if (cateName === "district") {
        return districtSub
    } else if (cateName === "international") {
        return internationalSub
    } else if (cateName === "industrybusiness") {
        return industrybusinessSub
    } else if (cateName === "finance") {
        return financeSub
    } else if (cateName === "work") {
        return workSub
    } else if (cateName === "hobby") {
        return hobbySub
    } else if (cateName === "food") {
        return foodSub
    } else if (cateName === "fashion") {
        return fashionSub
    } else if (cateName === "travel") {
        return travelSub
    } else if (cateName === "sport") {
        return sportSub
    } else if (cateName === "paternity") {
        return paternitySub
    } else if (cateName === "education") {
        return educationSub
    } else if (cateName === "culture") {
        return cultureSub
    } else if (cateName === "designandart") {
        return designandartSub
    } else if (cateName === "technology") {
        return technologySub
    } else if (cateName === "health") {
        return healthSub
    } else if (cateName === "theology") {
        return theologySub
    } else if (cateName === "relationship") {
        return relationshipSub
    } else if (cateName === "environmental") {
        return environmentSub
    }
}

export function generateSiteMap() {
    let sitemapStr = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:news="http://www.google.com/schemas/sitemap-news/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml" xmlns:mobile="http://www.google.com/schemas/sitemap-mobile/1.0" xmlns:image="http://www.google.com/schemas/sitemap-image/1.1" xmlns:video="http://www.google.com/schemas/sitemap-video/1.1">
    <url> <loc>https://mewesearcher.com/tips</loc> <lastmod>`+ (new Date()).getFullYear() + `-` + ((new Date()).getMonth() + 1) + `-` + (new Date()).getDate() +`</lastmod> <changefreq>daily</changefreq> <priority>0.9</priority></url>
    <url> <loc>https://mewesearcher.com/list</loc>  <lastmod>` + (new Date()).getFullYear() + `-` + ((new Date()).getMonth() + 1) + `-` + (new Date()).getDate() +`</lastmod> <changefreq>daily</changefreq> <priority>1</priority></url>
    <url> <loc>https://mewesearcher.com/search</loc>  <lastmod>`+ (new Date()).getFullYear() + `-` + ((new Date()).getMonth() + 1) + `-` + (new Date()).getDate() +`</lastmod> <changefreq>weekly</changefreq> <priority>0.9</priority></url>
    <url> <loc>https://mewesearcher.com/about</loc>  <lastmod>`  + (new Date()).getFullYear() + `-` + ((new Date()).getMonth() + 1) + `-` + (new Date()).getDate() +` </lastmod> <changefreq>weekly</changefreq> <priority>0.9</priority></url>
    <url> <loc>https://mewesearcher.com/</loc>  <lastmod>`+ (new Date()).getFullYear() + `-` + ((new Date()).getMonth() + 1) + `-` + (new Date()).getDate() +`</lastmod> <changefreq>weekly</changefreq> <priority>0.9</priority></url>
   `
    let sitemapBottom = `</urlset>`

    categories.map(ca => {
        sitemapStr += `<url> <loc>https://mewesearcher.com/c/` + ca.value + `</loc> <lastmod>` + (new Date()).getFullYear() + `-` + ((new Date()).getMonth() + 1) + `-` + (new Date()).getDate() + `</lastmod> <changefreq>daily</changefreq> <priority>1</priority> </url>`
        getSubCategories(ca.value).map(e => {
            sitemapStr += `<url> <loc>https://mewesearcher.com/c/` + ca.value + `?subCID=` + e.value + `</loc> <lastmod>` + (new Date()).getFullYear() + `-` + ((new Date()).getMonth() + 1) + `-` + (new Date()).getDate() + `</lastmod> <changefreq>daily</changefreq> <priority>0.9</priority> </url>`
        })
    })

    sitemapStr += sitemapBottom

    console.log(sitemapStr)

}